/* 
  http://wiki.xcharger.net  Portal前后端接口
  apis下每个文件对应wiki里每个大类。
  apis下每个文件里面的接口名称是wiki里的接口规格
  例如：login.js 里的“getMyInfo”对应wiki里的“	portal.getMyInfo”，便于快速定位接口文档

  vue文件使用：
  1、import $http from "@/api";
  2、$http.login.getMyInfo().then(res => {});
     $http.siteBuild.getCustomer().then(res => {});
     其中“login” “siteBuild”是模块的名称(apis下面的文件名称)
 */
const modules = import.meta.glob('./apis/*.js', { eager: true });   // 批量导入 /apis 文件夹下所有js文件
let allModules = {};  // 导出的对象
for (const path in modules) {
  let itemKey = path.replace('./apis/', '').replace('.js', '');   // 模块的名称
  allModules[itemKey] = modules[path];   // 对应模块的内容
}

export default allModules;
